
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, PlayCircle } from "lucide-react";

const CoursesSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="/images/20230730_100119.jpg" 
              alt="Videokursused" 
              className="rounded-lg shadow-md w-full"
            />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-medium mb-4">Videokursused</h2>
            <p className="text-gray-700 mb-6">
              Õpi omas tempos ja kohas läbi põhjalike videokursuste, mis annavad sulle praktilised oskused ja teadmised. Kursused on loodud sinu arengu toetamiseks, ühendades teoreetilise tausta praktiliste harjutustega.
            </p>
            
            <div className="mb-6">
              <div className="flex items-start space-x-3 mb-4">
                <PlayCircle className="h-6 w-6 text-kaija-slate flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="text-lg font-medium mb-1">Kvaliteetsed videomaterjalid</h3>
                  <p className="text-gray-700">
                    Professionaalselt salvestatud videod, mis on selged ja informatiivsed.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3 mb-4">
                <PlayCircle className="h-6 w-6 text-kaija-slate flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="text-lg font-medium mb-1">Praktiline lähenemine</h3>
                  <p className="text-gray-700">
                    Kõik kursused sisaldavad praktilisi harjutusi, mida saad kohe rakendada.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <PlayCircle className="h-6 w-6 text-kaija-slate flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="text-lg font-medium mb-1">Eluaegne juurdepääs</h3>
                  <p className="text-gray-700">
                    Osta kursus üks kord ja kasuta seda nii palju kui soovid.
                  </p>
                </div>
              </div>
            </div>
            
            <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white">
              <Link to="/courses" className="flex items-center">
                Vaata kursuseid <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
